__turbopack_context__.v({
  "badge": "H8G-na_badge",
  "statusMessage": "H8G-na_statusMessage",
});
